import React, { Component, PropTypes } from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { LogoutRequest } from 'client/features/session/actions'
import { ClientsRequest } from 'client/features/client/actions'
import Cut from 'client/features/common/components/Cut.jsx'
import { ReportsRequest, ExportReportsRequest, reportsFiltersChange } from 'client/features/reports/actions'
import { booleansCount, getDataLabel, getUser, getReportsByFilters, multipleCount, getFrameCount, getTypeLabel, isForType } from 'client/features/reports/lib'
import Filters from 'client/features/reports/components/Filters.jsx'
import DeleteReportModal from 'client/features/reports/components/DeleteReportModal.jsx'
import URLS from 'constant/URLS'
import FontAwesome from 'react-fontawesome'
import _ from 'underscore'
import moment from 'moment'
import { getSelectReportsOptions } from 'client/features/reports/lib'
import { makeEndpoint } from 'client/core/api'
import DatePicker from 'react-datepicker'

class Home extends Component {

    constructor() {
        super()
        this.export = this.export.bind(this)
        this.setFilters = this.setFilters.bind(this)
        this.updateDate = this.updateDate.bind(this)
        this.displayReportModal = this.displayReportModal.bind(this)
        this.deleteReport = this.deleteReport.bind(this)
        this.state = {
            fullCurrentReport: null,
            currentReport: null,
            editDate: false,
            showDeleteModal: false
        }
    }

    componentDidMount() {
        this.props.dispatch(ReportsRequest.get.action())
        this.props.dispatch(ClientsRequest.get.action())
        if (this.props.user && this.props.user.limited)
            window.location = "/"
    }

    displayReportModal(report) {
        this.setState({
            fullCurrentReport: report,
            showDeleteModal: !this.state.showDeleteModal
        })
    }

    deleteReport() {

    }

    logout() {
        LogoutRequest.get.action()
    }

    activeReport(currentReport) {
        if (this.state.currentReport === currentReport) currentReport = null
        this.setState({
            currentReport,
            editDate: false
        })
    }

    editDate() {
        this.setState({
            editDate: !this.state.editDate
        })
    }

    updateDate(date) {
        const { currentReport } = this.state
        this.props.dispatch(ReportsRequest.put.action({
            payload: { 
                date,
                _id: currentReport
            },
            params: {
                _id: currentReport
            }
        }))
        this.setState({
            editDate: false
        })
    }

    deleteReport() {
        const { currentReport } = this.state
        this.props.dispatch(ReportsRequest.delete.action({
            payload: {
                _id: currentReport
            },
            params: {
                _id: currentReport
            }
        }))
        this.setState({
            displayReportModal: false,
            currentReport: null,
            fullCurrentReport: null
        })
    }

    export() {
        this.props.dispatch(ExportReportsRequest.get.action({
            payload: { filters: this.props.reports.filters }
        }))
    }

    setFilters(filters, dispatch) {
        dispatch(reportsFiltersChange({ filters }))
    }

    render() {
        const { filters, search } = this.props.reports
        let hives = []
        this.props.client.all.filter(client => !client.disabled).forEach(client => 
            hives = hives.concat(client.hives.map(hive => ({ ...hive, client })))
        )
        hives = _.sortBy(hives, 'identifier')
        return (
            <div>
                <h3 className='page-title'>
                    Hives
                </h3>
                {
                    this.state.fullCurrentReport &&
                        <DeleteReportModal
                            show={ this.state.showDeleteModal }
                            display={ this.displayReportModal }
                            deleteReport={ this.deleteReport }
                            report={ this.state.fullCurrentReport }
                        />
                }
                <div className='card-box'>
                <table className='table table-striped m-0 header-fixed'>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Etat</th>
                            <th>Client</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            hives.filter(hive => !hive.deleted).map(hive =>
                                <tr key={ hive._id }>
                                    <td>{ hive.identifier }</td>
                                    <td>
                                        { hive.state === 'dead' && <span><FontAwesome name='warning' /> </span> }
                                        { hive.state === 'dead' ? 'Morte' : 'Vivante' }
                                    </td>
                                    <td>
                                        <Link to={ makeEndpoint(URLS.client.show, hive.client) }>
                                            { hive.client && hive.client.name }
                                        </Link>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
                </div>
            </div>
        )
    }
}

Home.contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
    user: PropTypes.object
}

const mapStateToProps = (state) => {
    const { session, reports, client } = state
    return { user: session.user, reports, client }
}

export default connect(mapStateToProps)(Home)


// WEBPACK FOOTER //
// ./src/client/features/hives/containers/Hives.jsx